import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostMinerRemoveOperation } from "../../api/api";

type MoveDGMemberResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

type TranfersInput = {
  serials: string[];
  siteName: string;
  dgname?: string;
};

export const useDeleteMiners = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      serials,
      siteName,
      dgname,

      token,
    }: TranfersInput & {
      token: string;
    }): Promise<MoveDGMemberResult> =>
      PostMinerRemoveOperation(token, {
        serials,
        siteName,
        dgname,
      }),

    onSuccess: (data) => {
      console.log("data", data);
    },

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { serials, siteName, dgname }: TranfersInput,
      options?: {
        onSuccess?: (data: MoveDGMemberResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          serials,
          siteName,
          dgname,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
